import client from '../../../apis/portaliref';
import helper from 'helpers/steinerHelper';

const apis = helper.createApi('indicatori', client, {
    per_page: 'perPage',
    page: 'page',
    ricerca: 'q',
    sort_field: 'orderKey',
    sort_direction: 'orderDirection',
    portale: 'portale',
    comune: 'comune',
    customer_category: 'customer_category',
    data_ultimo_contratto: 'data_ultimo_contratto',
    nascondi_contratto_inattivo: 'nascondi_contratto_inattivo',
    con_crm: 'con_crm',
    tipologia_landing: 'tipologia_landing',
    pacchetto: 'pacchetto',
    campagna: 'campagna',
});

apis.fetchNoteIndicatore = (idNotaIndicatore) => {
    return client({
        url: `notaIndicatore/${idNotaIndicatore}`,
        method: 'get',
    });
};

apis.aggiornaNotaIndicatore = (idNotaIndicatore, data) => {
    return client({
        url: `notaIndicatore/${idNotaIndicatore}`,
        method: 'patch',
        data: data,
    });
};

apis.elencoDestinazioni = () => {
    return client({
        url: 'destinazioni/listaNomi',
        method: 'GET',
    });
};

export default apis;
